import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateErrorComponent } from './template-error.component';
import { IdsModule } from 'src/app/ids.module';

@NgModule({
  declarations: [
    TemplateErrorComponent
  ],
  imports: [
    CommonModule,
    IdsModule
  ],
  exports: [
    TemplateErrorComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TemplateErrorModule { }
